
// * ========================================================================
// * vaccines per week chart
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from '../storage';
import { roundTo } from '../helpers';

const vaccinesPerRegion = (function(){
    let thisChart = null;
    let chartFirstDate = null;
    let chartData = null;
    let dataType = null;
    let typeSelectors = null;
    const typeSelectorClass = 'input[name=vaccines-per-age-week-chart-data]';
    moment.locale('fi');

    function createChartData(data, options, selected) {
        const datasets = [];
        const dates = {};

        const ageOrder = {
            all_ages: 0,
            age_0_4: 1,
            age_5_11: 2,
            age_12_17: 3,
            age_18_24: 4,
            age_20_24: 5,
            age_25_29: 6,
            age_30_34: 7,
            age_35_39: 8,
            age_40_44: 9,
            age_45_49: 10,
            age_50_54: 11,
            age_55_59: 12,
            age_60_64: 13,
            age_65_69: 14,
            age_70_74: 15,
            age_75_79: 16,
            age_80: 17
        }

        let idx = 0;
        const ageDatasetMap = {};
        for (const [key, age] of Object.entries(data.vaccines.ages)) {
            datasets.push({
                label: age,
                id: key,
                borderColor: options.chartColors[idx],
                barPercentage: 1,
                data: [],
                type: 'LineWithLine',
                fill: false,
                order: ageOrder[key],
                selected: selected && Array.isArray(selected) ? selected.indexOf(key) !== -1 : true,
                pointRadius: 0
            });

            ageDatasetMap[key] = datasets.length - 1;
            idx++;
        }

        const dose = parseInt(dataType);
        const doseData = data.vaccines.doses[dose - 1];

        // Per week
        for (const week of doseData.weeks) {
            const weekName = week.week;

            if (typeof dates[weekName] === 'undefined') {
                const weekArr = weekName.split('_');
                dates[weekName] = moment().year(weekArr[0]).day(1).week(weekArr[1]);
                dates[weekName].set({
                    hour: 0,
                    minute: 0,
                    second: 0
                });
            }

            const newWeek = dates[weekName];
            if (newWeek >= chartFirstDate) {
                for (let age of week.ages) {
                    let value = age.percentage;
                    const percent = value > 0 ? roundTo(value, 2) : 0;
                    datasets[ageDatasetMap[age.age]].data.push({
                        x: newWeek,
                        y: percent
                    });
                }
            }
        }

        return datasets;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;
        chartFirstDate = window.config.firstDayValues.vaccineWeeks;

        typeSelectors = document.querySelectorAll(typeSelectorClass);
        getDataType();

        // Initially selected
        let selectedVaccineAges = storage.getData('vaccines-per-age-week-chart_multiselect');
        if (!selectedVaccineAges || !Array.isArray(selectedVaccineAges)) {
            selectedVaccineAges = ['all_ages'];
        }

        const datasets = createChartData(chartData, window.config, selectedVaccineAges);

        thisChart = new CovidChart('vaccines-per-age-week-chart', {
            datasets,
            chartOptions: {
                type: 'line',
                options: {
                    plugins: {
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            position: 'nearest',
                            callbacks: {
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + tooltipItem.formattedValue + ' %';

                                    return label;
                                }
                            },
                            itemSort: function(a, b, data) {
                                const orderA = data.datasets[a.datasetIndex].order;
                                const orderB = data.datasets[b.datasetIndex].order;

                                return orderA < orderB ? 1 : -1;
                            },
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'week',
                                /*displayFormats: {
                                    day: 'D.M',
                                }*/
                            }
                        },
                        y: {
                            //max: 100,
                            min: 0,
                            ticks: {
                                precision: 0,
                                // Include a % sign in the ticks
                                callback: function(value, index, values) {
                                    return value + ' %';
                                }
                            }
                        }
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'vaccines-per-age-week-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'borderColor',
                inputName: 'vaccines-per-age-week-multiselect',
                selectElemId: 'vaccines-per-age-week-multiselect',
                colorElemId: 'vaccines-per-age-week-multiselect-colors',
                countElemId: 'vaccines-per-age-week-multiselect-count',
                selectAllElemId: 'vaccines-per-age-week-multiselect-select-all',
                clearAllElemId: 'vaccines-per-age-week-multiselect-clear-all'
            },
            responsive: ['aspectRatio']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        // New first date value
        chartFirstDate = window.config.firstDayValues.vaccineWeeks;


        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default vaccinesPerRegion;
